import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FontAwesomeIcon from './plugins/fontawesome'
import { initTheme } from './composables/useTheme'
import './assets/styles/global.css'

initTheme()

createApp(App)
  .use(router)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')

// PWA: Service Worker nur im Production-Build registrieren (Dev-Server + HMR vertragen kein Caching)
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {})
  })
}
